import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminTeam from "@/pages/AdminTeam";
import AdminSettings from "@/pages/AdminSettings";
import AdminPipeline from "@/pages/AdminPipeline";
import AdminCustomerDetail from "@/pages/AdminCustomerDetail";
import AdminContacts from "@/pages/AdminContacts";
import AdminMyTasks from "@/pages/AdminMyTasks";
import AdminReports from "@/pages/AdminReports";
import TermsAndConditions from "@/pages/TermsAndConditions";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AiDisclaimer from "@/pages/AiDisclaimer";
import AboutUs from "@/pages/AboutUs";
import { AuthProvider, RequireAdmin } from "@/lib/auth";
import { PipelineOptionsProvider } from "@/lib/pipelineOptions";

function App() {
  return (
    <div className="App font-poppins">
      <AuthProvider>
        <PipelineOptionsProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <RequireAdmin>
                  <AdminDashboard />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/team"
              element={
                <RequireAdmin>
                  <AdminTeam />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <RequireAdmin>
                  <AdminSettings />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/pipeline"
              element={
                <RequireAdmin>
                  <AdminPipeline />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/pipeline/:id"
              element={
                <RequireAdmin>
                  <AdminCustomerDetail />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/contacts"
              element={
                <RequireAdmin>
                  <AdminContacts />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/tasks"
              element={
                <RequireAdmin>
                  <AdminMyTasks />
                </RequireAdmin>
              }
            />
            <Route
              path="/admin/reports"
              element={
                <RequireAdmin>
                  <AdminReports />
                </RequireAdmin>
              }
            />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/ai-disclaimer" element={<AiDisclaimer />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
        </PipelineOptionsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
